import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class LandingPreviewOverlayContainer extends OverlayContainer {
    private host: HTMLElement | null = null;

    constructor(@Inject(DOCUMENT) document: any, platform: Platform) {
        super(document, platform);
    }

    setHost(host: HTMLElement | null): void {
        this.host = host;

        // ensure container exists & is moved to the correct parent
        const container = this.getContainerElement();

        // mark mode for CSS (optional but useful)
        if (this.host) {
            container.setAttribute('data-lp-overlay-mode', 'preview');
        } else {
            container.setAttribute('data-lp-overlay-mode', 'body');
        }

        // only needed for your connected overlay offset logic (if you use it)
        this.updateHostOffsetVars();
    }

    /** Update CSS vars (called on resize/scroll too) */
    updateHostOffsetVars(): void {
        const container = super.getContainerElement();

        // When the container is NOT in <body> (i.e. inside previewRoot),
        // do NOT apply any offset vars.
        if (!this.host || container.parentElement !== this._document.body) {
            container.style.setProperty('--lp-preview-offset-x', '0px');
            container.style.setProperty('--lp-preview-offset-y', '0px');
            return;
        }

        const rect = this.host.getBoundingClientRect();
        container.style.setProperty('--lp-preview-offset-x', `${rect.left}px`);
        container.style.setProperty('--lp-preview-offset-y', `${rect.top}px`);
    }

    override getContainerElement(): HTMLElement {
        const container = super.getContainerElement();

        // ✅ IMPORTANT: move overlays inside the phone frame when host exists
        const parent: HTMLElement = this.host ?? this._document.body;

        if (container.parentElement !== parent) {
            parent.appendChild(container);
        }

        return container;
    }
}
